import * as React from "react";
const SvgFiRrCowAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cow-alt_svg__a)">
      <path
        fill="#062147"
        d="M23.217 2H21.84c.103-.313.16-.649.16-1a1 1 0 1 0-2 0c0 .542-.36 1-.786 1h-4.428C14.36 2 14 1.542 14 1a1 1 0 1 0-2 0c0 .351.057.687.16 1h-1.377c-.533 0-.92.531-.737 1.031a3 3 0 0 0 2.32 1.927l.404 2.041H6.999a5 5 0 0 0-3.747 1.694L.34 11.248A1.001 1.001 0 0 0 1 13c.234 0 .47-.082.659-.248l.34-.299V21c0 1.654 1.347 3 3 3a3 3 0 0 0 2.62-1.539c2.065-.258 3.74-1.777 4.233-3.461H14v2c0 1.654 1.346 3 3 3s3-1.346 3-3v-4a1 1 0 1 0-2 0v4a1.001 1.001 0 0 1-2 0v-3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v3a1.001 1.001 0 0 1-2 0v-9q.001-.483.145-.92c.62.571 1.445.92 2.355.92a3.5 3.5 0 0 0 3.464-3h3.202l.332 1.68A2 2 0 0 0 15 14h4a2 2 0 0 0 1.502-3.32l1.13-5.721a3 3 0 0 0 2.322-1.927c.183-.5-.204-1.032-.737-1.032m-8.431 2h4.428q.3 0 .582-.066L18.596 10h-3.193l-1.2-6.066q.283.065.583.066"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cow-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCowAlt;
